/**
 * Axios Configuration for Auth0
 * Automatically includes Authorization header with access token
 * Handles 401 responses by triggering automatic logout
 */
import axios from 'axios';

let tokenProviderFunction = null;
let logoutHandler = null;

// Configure axios defaults
axios.defaults.baseURL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8010/v1';

// Request interceptor to add Authorization header
axios.interceptors.request.use(
  async (config) => {
    if (tokenProviderFunction) {
      try {
        const token = await tokenProviderFunction();
        if (token) {
          config.headers.Authorization = `Bearer ${token}`;
        }
      } catch (error) {
        console.error('Error getting access token:', error);
      }
    } else {
      console.log('No token provider function available');
    }
    
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor to handle 401 Unauthorized errors
axios.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response?.status === 401 && logoutHandler) {
      console.log('Session expired, logging out');
      await logoutHandler();
    }

    return Promise.reject(error);
  }
);

// Set the token provider function (called from AuthContext)
export const setTokenProvider = (tokenProvider) => {
  tokenProviderFunction = tokenProvider;
};

// Set the logout handler function (called from AuthContext)
export const setLogoutHandler = (handler) => {
  logoutHandler = handler;
};

export default axios;